export default __webpack_public_path__ + "static/media/Mask Group 7@2x.46a50bc5.png";